if (!customElements.get('worth-product-tabs')) {
  customElements.define(
    'worth-product-tabs',
    class WorthProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      activateTab(activeTab, moveFocus = false) {
        const target = activeTab.dataset.worthTab;

        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.worthPanel !== target;
        });

        if (moveFocus) activeTab.focus();
      }

      onKeydown(event, currentIndex) {
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        }
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }
    }
  );
}
